__webpack_require__.p = "/strchstellar_frontend/app/";